(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-writer"] && !Shopify.designMode) return;
  try {
    
(function() {
  var el = document.querySelector('[data-rv-writer]');
  if (!el) return;

  var STORAGE_KEY = 'recentlyViewedProduct';
  var maxItems = parseInt(el.getAttribute('data-rv-max') || '8', 10);
  var productJSON = el.getAttribute('data-rv-product');
  if (!productJSON) return;

  // --- helpers ---
  function normalizeSrc(u) {
    if (!u) return '';
    // Shopify often outputs //cdn...
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }
  function isNonEmptyString(v) {
    return typeof v === 'string' && v.trim().length > 0;
  }
  function isValidItem(it) {
    return it && typeof it === 'object' &&
      isNonEmptyString(it.url) &&
      isNonEmptyString(it.title) &&
      isNonEmptyString(it.price) &&
      (isNonEmptyString(it.img600) || isNonEmptyString(it.img300));
  }
  function sanitizeItem(it) {
    if (!it) return null;
    var obj = {
      url: isNonEmptyString(it.url) ? it.url : '',
      title: isNonEmptyString(it.title) ? it.title : '',
      price: isNonEmptyString(it.price) ? it.price : '',
      alt: isNonEmptyString(it.alt) ? it.alt : ''
    };
    obj.img600 = normalizeSrc(it.img600 || '');
    obj.img300 = normalizeSrc(it.img300 || '');
    return isValidItem(obj) ? obj : null;
  }
  function cleanArray(arr) {
    if (!Array.isArray(arr)) return [];
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var s = sanitizeItem(arr[i]);
      if (!s) continue;
      if (seen[s.url]) continue;      // de-dupe by URL
      seen[s.url] = true;
      out.push(s);
    }
    return out;
  }

  try {
    // parse incoming product and sanitize
    var incoming = sanitizeItem(JSON.parse(productJSON));
    if (!incoming) {
      // nothing valid to save
      return;
    }

    // read, clean, and de-dupe existing
    var existingRaw = [];
    try { existingRaw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) {}
    var existing = cleanArray(existingRaw);

    // if already present, move it to the end (most recent)
    var withoutIncoming = existing.filter(function(p){ return p.url !== incoming.url; });
    var next = withoutIncoming.concat([incoming]);

    // cap length
    if (next.length > maxItems) {
      next = next.slice(next.length - maxItems);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (e) {
    console.warn('Recently Viewed writer: cannot write localStorage', e);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'recentlyViewedProduct';

  function renderSection(root) {
    if (!root) return;
    var grid = root.querySelector('[data-rv-grid]');
    if (!grid) return;

    var items = [];
    try { items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) {}

    // keep only valid products
    items = (items || []).filter(function (item) {
      return item && typeof item === 'object' &&
             item.url && item.title && item.price &&
             (item.img600 || item.img300);
    });

    if (!items.length) {
      root.hidden = true;
      grid.innerHTML = '';
      return;
    }

    root.hidden = false;

    // latest first
    var list = items.slice().reverse();

    var html = list.map(function (item) {
      var src = item.img600 || item.img300 || '';
      var srcsetParts = [];
      if (item.img300) srcsetParts.push(item.img300 + ' 300w');
      if (item.img600) srcsetParts.push(item.img600 + ' 600w');
      var srcset = srcsetParts.join(', ');

      return '' +
        '<li class="recently-viewed-grid-item">' +
          '<a href="' + item.url + '">' +
            '<img class="recently-viewed-img" src="' + src + '" ' +
              (srcset ? 'srcset="' + srcset + '" sizes="(max-width: 749px) 50vw, (max-width: 989px) 33vw, 25vw" ' : '') +
              'loading="lazy" alt="' + (item.alt ? item.alt.replace(/"/g, '&quot;') : '') + '">' +
          '</a>' +
          '<h3><a class="recently-viewed-a" href="' + item.url + '">' + item.title + '</a></h3>' +
          '<p>' + item.price + '</p>' +
        '</li>';
    }).join('');

    grid.innerHTML = html;
  }

  // render all viewer sections now
  var sections = document.querySelectorAll('section[data-rv-root]');
  if (sections.length) {
    sections.forEach(renderSection);
  }

  // re-render on bfcache restore (back/forward)
  window.addEventListener('pageshow', function () {
    if (sections.length) sections.forEach(renderSection);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
